import {productAvailabilityStyles as styles} from "@tggstore/Overrides/Components/ProductAvailability";
import { css } from "styled-components";

styles.productErpWrapper = {
    ...styles.productErpWrapper,
    css: css`
            padding: 10px 10px 10px 20px;
            font-size: 16px;
        `,
};
